import { Injectable } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';

import { AddUserModalComponent } from './add-user-modal.component';

@Injectable()
export class AddUserModalService {

   newUser;

   constructor(private readonly dialog: MatDialog) { }

   showModal() {
      let dialogRef: MatDialogRef<AddUserModalComponent>;

      this.newUser = null;

      dialogRef = this.dialog.open(
         AddUserModalComponent,
         {
            height: '640px',
            disableClose: true
         }
      );

      dialogRef.afterClosed().subscribe();

      return dialogRef;
   }
}
